// @TODO - Crear un switch para asegurar notas en contactos.
// El ajax callback nececita otros parametros.
import st from '../lib/str_tool';

export default class ContactsFavoritesNotices {
  constructor(el) {
    this.el = el;
    this.module = this.el.getAttribute('data-module-name');
    this.currentId = this.el.getAttribute('data-current-id');
    this.modalId = this.el.getAttribute('data-modal-id');
    this.modalContainer = this.el.querySelector(this.modalId);
    this.noNoticeStr = this.modalContainer.getAttribute('data-no-notices');
    this.noticeView = this.modalContainer.querySelector('#notice-view');
    this.noticeViewContent = this.noticeView.querySelector('p');
    this.noticeEdit = this.modalContainer.querySelector('#notice-edit');
    this.modalTextarea = this.modalContainer.querySelector('textarea');
    this.editNoteButton = this.modalContainer.querySelector('.edit-note');
    this.deleteNoteButton = this.modalContainer.querySelector('.delete-note');
    this.saveNoteButton = this.modalContainer.querySelector('.save-note');
    this.abortNoteButton = this.modalContainer.querySelector('.abort-note');
    this.items = this.el.querySelectorAll('a.notice-button');
    this.lang = st.getLang();
    this.testDate = st.formatDate(this.lang);
    this.saveMode =
      this.module === 'favorites' ? 'savenote' : 'SaveContactNote';
    this.deleteMode =
      this.module === 'favorites' ? 'delnote' : 'SaveContactNote';
    this.init();
  }

  /* eslint-disable class-methods-use-this */
  init() {
    this.items.forEach(item => {
      item.addEventListener('click', e => {
        let button = e.target;
        if (e.target.nodeName === 'I') {
          button = e.target.parentNode;
        }
        // const testDate = st.formatDate(this.lang);
        const noteId = parseInt(button.getAttribute('data-notice-id'), 10);
        const textDivId = button.getAttribute('data-notice-selector').trim();
        const textDiv = document.querySelector(textDivId);
        this.noticeViewContent.innerHTML = textDiv.innerHTML.replace(
          /\n/gi,
          '<br>'
        );
        let myText = textDiv.innerHTML
          .replace(/(<\/?font.*?>)/gi, '')
          .replace(/&lt;/gi, '<')
          .replace(/&gt;/gi, '>')
          .trim();
        const hasContent = myText.length;
        myText = hasContent
          ? `${myText}\n[${this.testDate}] `
          : `[${this.testDate}] `;

        if (hasContent) {
          this.setStates('view-full');
        } else {
          this.setStates('view-empty');
        }
        this.noticeView.scrollIntoView();
        this.modalTextarea.value = st.br2nl(myText, 1);
        this.modalTextarea.setAttribute('data-note-id', noteId);
        this.modalTextarea.setAttribute('data-note-raw', textDivId);
      });
    });
    this.abortNoteButton.addEventListener('click', () => {
      this.clear(this.modalTextarea.getAttribute('data-note-id'));
    });
    this.editNoteButton.addEventListener('click', () => {
      this.editTheNote(this.modalTextarea.getAttribute('data-note-id'));
    });
    this.deleteNoteButton.addEventListener('click', () => {
      this.deleteTheNote();
    });
    this.saveNoteButton.addEventListener('click', () => {
      this.saveTheNote(this.modalTextarea.value);
    });
  }

  saveTheNote(notetext) {
    this.noticeViewContent.innerHTML = this.modalTextarea.value.replace(
      /\n/gi,
      '<br>'
    );
    document.querySelector(
      this.modalTextarea.getAttribute('data-note-raw')
    ).innerHTML = this.modalTextarea.value.trim();
    const nId = this.modalTextarea.getAttribute('data-note-id');
    document.getElementById(`edit-link-notice-${nId}`).classList.remove('grey');
    const data = {
      json: true,
      note: notetext.trim(),
      id: this.modalTextarea.getAttribute('data-note-id'),
      mode: this.saveMode
    };
    if (this.module === 'contacts') {
      data.profileId = this.currentId;
    }
    // Send data to server
    $.post(
      '/ajax.php',
      data,
      () => {
        // if (response) console.log('response');
        this.setStates('save');
      },
      'json'
    );
  }

  setStates(mod) {
    switch (mod) {
      case 'save':
        this.noticeEdit.style.display = 'none';
        this.saveNoteButton.style.display = 'none';
        this.abortNoteButton.style.display = 'none';
        this.deleteNoteButton.style.display = '';
        this.noticeView.style.display = '';
        this.editNoteButton.style.display = '';
        break;
      case 'delete':
        this.noticeEdit.style.display = 'none';
        this.saveNoteButton.style.display = 'none';
        this.deleteNoteButton.style.display = 'none';
        this.abortNoteButton.style.display = 'none';
        this.noticeView.style.display = '';
        this.editNoteButton.style.display = '';
        this.noticeViewContent.innerHTML = this.noNoticeStr;
        break;
      case 'view-full':
        this.noticeEdit.style.display = 'none';
        this.saveNoteButton.style.display = 'none';
        this.abortNoteButton.style.display = 'none';
        this.deleteNoteButton.style.display = '';
        this.noticeView.style.display = '';
        this.editNoteButton.style.display = '';
        break;
      case 'view-empty':
        this.noticeView.style.display = 'none';
        this.editNoteButton.style.display = 'none';
        this.deleteNoteButton.style.display = 'none';
        this.noticeEdit.style.display = '';
        this.saveNoteButton.style.display = '';
        break;
      case 'edit':
        this.editNoteButton.style.display = 'none';
        this.noticeView.style.display = 'none';
        this.abortNoteButton.style.display = '';
        this.saveNoteButton.style.display = '';
        this.deleteNoteButton.style.display = '';
        this.noticeEdit.style.display = '';
        break;
      default: // Do nothing
    }
  }

  editTheNote() {
    this.setStates('edit');
  }

  deleteTheNote() {
    const data = {
      json: true,
      id: this.modalTextarea.getAttribute('data-note-id'),
      mode: this.deleteMode
    };
    if (this.module === 'contacts') {
      data.profileId = this.currentId;
    }
    // Send data to server
    $.post(
      '/ajax.php',
      data,
      () => {
        // if (response) console.log('response');
        this.setStates('delete');
        document.querySelector(
          this.modalTextarea.getAttribute('data-note-raw')
        ).innerHTML = '';
        this.modalTextarea.value = `[${this.testDate}] `;
        const nId = this.modalTextarea.getAttribute('data-note-id');
        document
          .getElementById(`edit-link-notice-${nId}`)
          .classList.add('grey');
      },
      'json'
    );
  }

  clear() {
    this.modalTextarea.value = '';
    this.noticeViewContent.innerHTML = '';
    this.modalTextarea.setAttribute('data-note-id', '');
    this.modalTextarea.setAttribute('data-note-raw', '');
  }

  tres() {}
  /* eslint-enable class-methods-use-this */
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/contacts_favorites_notices.js